// 登记注册

import React from 'react';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import Cache from '../../frame/Cache';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';
import { Descriptions } from 'antd';
import '../../css/analysis.css';
import WidgetTable from '../../widget/WidgetTable';

class Ckjz extends React.Component 
{   
    constructor()
    {
        super();

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        
        let basePath = Config.getBasePath();

        let entname = Widget.getSessionStorage("entname");

        this.state = {
            url : url,
            basePath:basePath,
            loading:true,
            params :{
                'user':UID,
                'ENTNAME' : entname
            }
        };

        // this.onGetEntityBankRelationship = this.onGetEntityBankRelationship.bind(this);
        
        Config.getHermesAccess( this.onLoadToken );
    };

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }
    

    render()
    {
        const {baseInfo, url, params, column1, column2, column3,loading, assetEvalInfo, activeType, column4, column5, data1, data2, data3, data4} = this.state;

        return(
            <div className="page">
                
                <div className="page-content page-overflow entity-content white padding-20" style={{display:"table"}}>
                    <div className="content-top">
                        <div id="baseInfo" className="entity-baseInfo">
                            <div className="content-title">
                                <div className="img">
                                    <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                                </div>
                                <div className="font">
                                    <span>存款价值</span>
                                </div>
                            </div>
                            <div className="baseInfo">
                                <>{loading?<p className="registration-loading"><img src={require('../../img/frame/loading.gif')} className="loading-registration" alt="es-lint want to get"/></p>:
                                     <Descriptions title="User Info">
                                        <Descriptions.Item label="UserName">Zhou Maomao</Descriptions.Item>
                                        <Descriptions.Item label="Telephone">1810000000</Descriptions.Item>
                                        <Descriptions.Item label="Live">Hangzhou, Zhejiang</Descriptions.Item>
                                        <Descriptions.Item label="Remark">empty</Descriptions.Item>
                                        <Descriptions.Item label="Address">
                                        No. 18, Wantang Road, Xihu District, Hangzhou, Zhejiang, China
                                        </Descriptions.Item>
                                    </Descriptions>
                                }</>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        );
    }
}

export default Ckjz;
